import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { DsiCurrencyPipe } from './dsi-currency.pipe';

@NgModule({
    declarations: [DsiCurrencyPipe],
    imports: [CommonModule],
    exports: [DsiCurrencyPipe],
    providers: [CurrencyPipe],
})
export class DsiCurrencyModule {}
